<template>
  <div class="form-wrapper">
    <ElForm 
      inline 
      labelPosition="right" 
      ref="formRef" 
      statusIcon
      :model="formData.form"
      >
      <!-- <ElRow>
        <ElFormItem 
          label="动态标签" 
          prop="version"
          label-width="90">
          <ElSelect 
            filterable 
            multiple 
            collapseTags 
            collapseTagsTooltip
            v-model="formData.form.checkedEventTags"
            style="width: 350px;margin-right: 10px;">
            <el-option 
              v-for="flag in eventTagList"
              :key="flag.ruleId"
              :label="flag.tag"
              :value="flag.ruleId"
            />
          </ElSelect>

          <ElFormItem 
            prop="role">
            <ElCheckbox v-model="formData.form.isCheckedAllEventTags"
            label="全选" />
          </ElFormItem>
        </ElFormItem>
      </ElRow> -->
      <ElRow>
        <ElFormItem 
          label="alarmCode" 
          prop="version"
          label-width="90">
          <ElSelect 
            filterable 
            multiple 
            collapseTags 
            collapseTagsTooltip
            v-model="formData.form.checkedAlarmCodeList"
            style="width: 350px;margin-right: 10px;">
            <el-option 
              v-for="code in alarmCodeList"
              :key="code.alarmCode"
              :label="code.alarmCodeString"
              :value="code.alarmCode"
            />
          </ElSelect>

          <ElFormItem 
            prop="role">
            <ElCheckbox v-model="formData.form.isCheckedAllAlarmCode"
            label="全选" />
          </ElFormItem>
        </ElFormItem>
      </ElRow>
      <ElRow>
        <ElFormItem 
          label="标记_旗子" 
          prop="role"
          label-width="90">
          <ElCheckboxGroup 
            v-model="formData.form.varguardVisible">
            <ElCheckbox 
              value='varguardFristFatal' 
              label="varguardFristFatal"
            >varguardFristFatal
            </ElCheckbox>
            <ElCheckbox value='varguardError' label="varguardError">varguardError</ElCheckbox>
            <ElCheckbox value='varguardFatal' label="varguardFatal">varguardFatal</ElCheckbox>
          </ElCheckboxGroup>
        </ElFormItem>
      </ElRow>
      <ElRow>
        <ElFormItem 
          label="地图元素ID" 
          prop="role"
          label-width="90"
          >
          <ElCheckbox v-model="formData.form.mapLabelVisible"/>
        </ElFormItem>
        <ElFormItem
          label="自动打开图表"
          prop="role"
          label-width="100"
          >
          <ElCheckbox v-model="formData.form.autoOpenChart"/>
        </ElFormItem>
      </ElRow>
      <ElRow justify="center">
        <ElButton 
          type="primary"
          style="width: 100px;
          "
          @click="handleSubmit">
          提交
        </ElButton>
      </ElRow>
    </ElForm>
  </div>
</template>
<script setup>
import { onMounted, reactive, ref, watch } from 'vue';
import { useStore } from '@/store';
import { ElRow } from 'element-plus';

const store = useStore();
const props = defineProps({
  onSubmitSuccess: {
    type: Function,
    default: () => { },
  }
});


const formData = reactive({
  form: {
    checkedEventTags: store.state.checkedEventTags,
    varguardVisible: store.state.varguardVisible,
    mapLabelVisible: store.state.mapLabelVisible == "1" ? true : false,
    isCheckedAllEventTags: false,
    isCheckedAllAlarmCode:false,
    checkedAlarmCodeList:store.state.checkedAlarmCodeList,
    autoOpenChart: JSON.parse(localStorage.getItem('autoOpenChart') ?? 'false'),
  },
})

const formRef = ref();
const eventTagList = ref([]);
const alarmCodeList = ref([]);

const handleDuplicateRemove = (duplication,key)=>{
 const arr  = Array.from(
    new Set(duplication.map(tag => tag[key]))
  ).map(ruleId =>
    duplication.find(tag => tag[key] === ruleId)
  );
  return arr;
}

onMounted(() => {
  eventTagList.value = handleDuplicateRemove(store.state.allEventTags,'ruleId')
  eventTagList.value.forEach((item) => {
    if (item.tag) {
      item.tag = item.tag.replace(/\(.*?\)/, '').trim();
    }
  })
  alarmCodeList.value = handleDuplicateRemove(store.state.alarmCodeList,'alarmCode');

  if (
    formData.form.checkedEventTags.length === eventTagList.value.length
  ) {
    formData.form.isCheckedAllEventTags = true;
  }

  if(formData.form.checkedAlarmCodeList.length===alarmCodeList.value.length){
    formData.form.isCheckedAllAlarmCode = true;
  }
})

watch(
  () => formData.form.isCheckedAllEventTags,
  (isCheckedAllEventTags) => {
    if (isCheckedAllEventTags) {
      formData.form.checkedEventTags = eventTagList.value.map(
        ({ ruleId }) => ruleId,
      );
    } else {
      if (
        formData.form.checkedEventTags.length === eventTagList.value.length
      ) {
        formData.form.checkedEventTags = [];
      }
    }
  },
);

watch(
  () => formData.form.isCheckedAllAlarmCode,
  (isCheckedAllAlarmCode) => {
    if (isCheckedAllAlarmCode) {
      formData.form.checkedAlarmCodeList = alarmCodeList.value.map(
        ({ alarmCode }) => alarmCode,
      );
    } else {
      if (
        formData.form.checkedAlarmCodeList.length === alarmCodeList.value.length
      ) {
        formData.form.checkedAlarmCodeList = [];
      }
    }
  },
);

watch(
  () => formData.form.checkedAlarmCodeList,
  (checkedAlarmCode) => {
    if (checkedAlarmCode.length === alarmCodeList.value.length) {
      formData.form.isCheckedAllAlarmCode = true;
    } else {
      formData.form.isCheckedAllAlarmCode = false;
    }
  },
);

watch(
  () => formData.form.checkedEventTags,
  (checkedEventTags) => {
    if (checkedEventTags.length === eventTagList.value.length) {
      formData.form.isCheckedAllEventTags = true;
    } else {
      formData.form.isCheckedAllEventTags = false;
    }
  },
);

const handleSubmit = () => {
  const { checkedEventTags, varguardVisible, mapLabelVisible,checkedAlarmCodeList, autoOpenChart } = formData.form;

  store.commit('setCheckedEventTags', checkedEventTags);
  store.commit('setVarguardVisible', varguardVisible);
  store.commit('setMapLabelVisible', mapLabelVisible ? "1" : "0");
  store.commit('setCheckedAlarmCode',checkedAlarmCodeList);
  localStorage.setItem('autoOpenChart', JSON.stringify(autoOpenChart));
  props.onSubmitSuccess();
}

</script>
<style lang="less">
.form-wrapper {
  display: flex;
  justify-content: center;
}
</style>